// salary-calculator-tool

//port React from 'react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { inject as injectAnalytics } from '@vercel/analytics'
import { injectSpeedInsights } from '@vercel/speed-insights'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Enable Vercel Analytics & Speed Insights in production
if (process.env.NODE_ENV === 'production') {
  try {
    injectAnalytics()
  } catch (e) {
    // no-op
  }
  try {
    injectSpeedInsights()
  } catch (e) {
    // no-op
  }
}
